<template>
  <div
    class="aha-team-avatar"
    :class="[
      {'active': isActive}
    ]"
    :style="{width: `${width}px`, height: `${height}px`}"
  >
    <div
      v-if="image"
      class="aha-team-avatar__image"
      :class="[
        {'hover' : isHover, circle: circle},
      ]"
      :style="{width: `${width-3}px`, height: `${height-3}px`}"
    >
      <img :src="image">
    </div>
    <div
      v-else
      class="aha-team-avatar__image"
      :class="[
        {'hover' : isHover, circle: circle},
      ]"
      :style="{backgroundColor: avatarColor, width: `${width-3}px`, height: `${height-3}px`}"
    >
      {{ showingName | textAvatar }}
    </div>
  </div>
</template>

<script>
import colorUtil from '../../utils/colors'

export default {
  props: {
    isHover: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Unknown',
    },
    id: {
      type: Number,
      default: null,
    },
    circle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showingName() {
      return this.name || 'Unknown'
    },
    avatarColor() {
      const id = this.id ? this.id : this.showingName.charCodeAt(0)
      return colorUtil.getRandomColor(id)
    },
  },

}
</script>

<style lang="scss" scoped>
.aha-team-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  flex-shrink: 0;
  &.active {
    border: 2px solid #348EF6;
    border-radius: 12px;
  }
}

.aha-team-avatar__image {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: uppercase;
  border-radius: 8px;
  margin: auto;
  width: 100%;
  height: 100%;
  &.hover {
    transition: border-width 2s ease-in-out;
    border: 1px solid #348EF6;
  }
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.circle {
    @apply rounded-full;
  }
}
</style>
